import styled from 'styled-components';

import { TextLeftBlock, VerticalHorizontalCenterBlock } from '../../../styled';

export const TitleIconWrapper = styled.div`
  margin-right: 8px;
  max-width: 24px;
  max-height: 24px;

  svg {
    height: 100%;
    width: 100%;
  }
`;

export const SocialSettingsTitleBlock = styled(VerticalHorizontalCenterBlock)`
  margin-bottom: 24px;
`;

export const SocialSettingsTitle = styled.h1`
  font-size: 18px;
  line-height: 32px;
`;

export const SocialSettingsBlock = styled(TextLeftBlock)`
  margin-bottom: 12px;
`;

export const SocialSettingsSubtitle = styled.p`
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.muted};
  margin-bottom: 12px;
`;
